module.exports = __webpack_public_path__ + "img/error.b409c484.svg";